import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Geo.Renderer.ASCScaleExt = function() {

  this.draw = function(layer, content, conf, context, style, data, revision, dl) {

    var valid = true;
    if ( this.context_revision != revision.context ) {
      valid = false;
    }

    if ( this.content_revision != revision.content ) {
      valid = false;
    }

    if ( this.conf_revision != revision.conf ) {
      valid = false;
      dl.length = 0;
    }

    if ( valid )
      return;

    var s = conf.Attributes.style.default;
    if ( style && conf.Attributes.style[style] )
      s = conf.Attributes.style[style];
    if ( !s ) {
      layer.setStatus({status:"error", reason:"style definition error."});
      return;
    }

    layer.setStatus({status:"invalid", reason:"data load waiting."});

    var grid = data._handler().getGrid();
    if ( !grid )
      return;

    var gw = parseInt(grid.Width);
    var gh = parseInt(grid.Height);

    var sampling = "highest";
    if ( s.min_blocksize )
      sampling += (" "+s.min_blocksize);

    if ( !content || !content.element || !content.level )
      return;
    var element = Array.isArray(content.element)?content.element:[content.element];
    var level = Array.isArray(content.level)?content.level:[content.level];

    var rc = {};
    for ( var key in content ) {
      if ( key != 'element' && key != 'level' )
        rc[key] = content[key];
    }

    var tiles = []; // [elememt][level][tile]
    for ( var e = 0 ; e < element.length ; e++ ) {
      tiles[e] = [];
      for ( var l = 0 ; l < level.length ; l++ ) {
        tiles[e][l] = [];
      }
    }
    var waiting = false;
    for ( var i = 0 ; i < context.tiles.length ; i++ ) {
      var tile = context.tiles[i];
      for ( var e = 0 ; e < element.length ; e++ ) {
        rc.element = element[e];
        for ( var l = 0 ; l < level.length ; l++ ) {
          rc.level = level[l];
          var data_tile;
          if ( !(data_tile = data._handler().getTile(rc, tile.id, sampling)) ) {
            waiting = true;
            data._handler().loadTile(rc, tile.id, sampling, tile.z, tile.y, tile.x, tile.cood, tile.bounds,
              function() {
                WRAP.Geo.redraw(layer);
              });
          }
          tiles[e][l][i] = data_tile;
        }
      }
    }
    if ( waiting )
      return;

    layer.clear();

    var step;
    var vm = new Uint8Array(gw*gh);
    var pos = [];
    /* priority
        ICE(1)=1
        CONV(1)=2
        ICE(2)=3
        TURB(3)=4
        CONV(2)=5
        TURB(4)=6
        TURB(5)=7
    */
    for ( var e = 0 ; e < element.length ; e++ ) {
      var ev = element[e];
      for ( var l = 0 ; l < level.length ; l++ ) {
        var el = tiles[e][l];
        for ( var i = 0 ; i < el.length ; i++ ) {
          var data = el[i].data;
          for ( var j = 0 ; j < data.length ; j++ ) {
            var v = data[j];
            if ( !v.value || isNaN(v.value) || !v.step )
              continue;
            var value = 0;
            if ( ev == 'ICING' ) {
              if ( v.value == 1 )
                value = 1;
              else if ( v.value == 2 )
                value = 3;
            }
            else if ( ev == 'CONV' ) {
              if ( v.value == 1 )
                value = 2;
              else if ( v.value == 2 )
                value = 5;
            }
            else if ( ev == 'TURB' ) {
              if ( v.value == 3 )
                value = 4;
              else if ( v.value == 4 )
                value = 6;
              else if ( v.value == 5 )
                value = 7;
            }
            if ( value ) {
              var index = v.y*gw+v.x;
              if ( !vm[index] || vm[index] < value ) {
                vm[index] = value ;
                pos[index] = {lat:v.lat, lon:v.lon};
                step = v.step;
              }
            }
          }
        }
      }
    }

    var iceLgtPath = [];
    var iceModPath = [];
    var convLgtPath = [];
    var convModPath = [];
    var turbModPath = [];
    var turbMod2SevPath = [];
    var turbSevPath = [];

    function getTargetItem(v) {
      var target;
      switch (v) {
        case 1:
          target = iceLgtPath;
          break;
        case 2:
          target = convLgtPath;
          break;
        case 3:
          target = iceModPath;
          break;
        case 4:
          target = turbModPath;
          break;
        case 5:
          target = convModPath;
          break;
        case 6:
          target = turbMod2SevPath;
          break;
        case 7:
          target = turbSevPath;
          break;
        default:
          target = []
      }
      return target;
    }

    if ( step ) {
      var gxd = parseFloat(grid.LonInterval)*step;
      var gyd = parseFloat(grid.LatInterval)*step;
      var gxh = gxd/2;
      var gyh = gyd/2;

      var i = 0;

      for ( var y = 0 ; y < gh ; y++ ) {
        var prevValue = -1;
        var prevX = -1;
        var itemPath = {}
        for ( var x = 0 ; x < gw ; x++ ) {
          var v = vm[i];
          if ( v !== 0 ) {
            var p = pos[i];
            var sx = p.lon-gxh;
            var ex = p.lon+gxh;
            var sy = p.lat+gyh;
            var ey = p.lat-gxh;

            if ( sy > 85  || ey < -85 ) {
              i++;
              continue;
            }

            //Featureの数を削減するため、隣り合うblockと同じvalueの場合はグルーピングする
            if (prevValue === -1 || prevValue === 0) {
              itemPath = {sx: sx, ex:ex, sy:sy, ey:ey};
            } else if (prevValue === v && x -1 === prevX) {
              //グルーピング
              itemPath.ex = ex;
            } else {
              //隣と値が変わっているため、書き出し対象に追加
              getTargetItem(prevValue).push(
                [[itemPath.sx, itemPath.sy], [itemPath.ex, itemPath.sy], [itemPath.ex, itemPath.ey], [itemPath.sx, itemPath.ey], [itemPath.sx, itemPath.sy]]
              );
              itemPath = {sx: sx, ex:ex, sy:sy, ey:ey};
            }
          } else {
            if (prevValue > 0) {
              //隣と値が変わっているため、書き出し対象に追加
              getTargetItem(prevValue).push(
                [[itemPath.sx, itemPath.sy], [itemPath.ex, itemPath.sy], [itemPath.ex, itemPath.ey], [itemPath.sx, itemPath.ey], [itemPath.sx, itemPath.sy]]
              );
            }
          }
          prevX = x;
          prevValue = v;
          i++;
        }
        //xの最後を書き出し対象に追加
        if (prevValue > 0) {
          getTargetItem(prevValue).push(
            [[itemPath.sx, itemPath.sy], [itemPath.ex, itemPath.sy], [itemPath.ex, itemPath.ey], [itemPath.sx, itemPath.ey], [itemPath.sx, itemPath.sy]]
          );
        }
      }
    }

    if (iceLgtPath.length) {
      layer.addFeature(new WRAP.Geo.Feature.GeoLine({
        path:iceLgtPath,
        fillStyle: s.icing_lgt_color,
        method: "RL"
      }));
    }

    if (iceModPath.length) {
      layer.addFeature(new WRAP.Geo.Feature.GeoLine({
        path:iceModPath,
        fillStyle: s.icing_mod_color,
        method: "RL"
      }));
    }

    if (convLgtPath.length) {
      layer.addFeature(new WRAP.Geo.Feature.GeoLine({
        path:convLgtPath,
        fillStyle: s.conv_lgt_color,
        method: "RL"
      }));
    }

    if (convModPath.length) {
      layer.addFeature(new WRAP.Geo.Feature.GeoLine({
        path:convModPath,
        fillStyle: s.conv_mod_color,
        method: "RL"
      }));
    }

    if (turbModPath.length) {
      layer.addFeature(new WRAP.Geo.Feature.GeoLine({
        path:turbModPath,
        fillStyle: s.turb_mod_color,
        method: "RL"
      }));
    }

    if (turbMod2SevPath.length) {
      layer.addFeature(new WRAP.Geo.Feature.GeoLine({
        path:turbMod2SevPath,
        fillStyle: s.turb_mod_to_sev_color,
        method: "RL"
      }));
    }

    if (turbSevPath.length) {
      layer.addFeature(new WRAP.Geo.Feature.GeoLine({
        path:turbSevPath,
        fillStyle: s.turb_sev_color,
        method: "RL"
      }));
    }

    // Check Grid Rank
    var check = false;
    if ( check) {
      var i = 0;
      for ( var y = 0 ; y < gh ; y++ ) {
        for ( var x = 0 ; x < gw ; x++ ) {
          var v = vm[i];
          if ( v ) {
            var p = pos[i];
            var feature;
            feature = new WRAP.Geo.Feature.Text({
              point:[p.lon,p.lat],
              text:v,
              fontSize:12,
              fillStyle:'#000',
              offsetX:0,
              offsetY:6,
              align:'center'
            });
            layer.addFeature(feature);
          }
          i++;
        }
      }
    }

    this.context_revision = revision.context;
    this.content_revision = revision.content;
    this.conf_revision = revision.conf;
    layer.setStatus({status:"valid"});
    WRAP.Geo.invalidate();
  }
};
/* eslint-enable */